/**
 * Headline "as low as $X/mo" figure for the financing-forward treatment —
 * shared by the quote-summary hero (QuoteSummaryTreatment) and the photos
 * welcome modal (StepPhotos) so the two surfaces can never drift.
 *
 * A 60-month display estimate (12.5% APR-style factor). This is NOT a lender
 * quote — every surface that shows it pairs it with "subject to approval".
 */
export const estimateMonthlyPayment = (totalDollars: number): number =>
  Math.round((totalDollars * 0.125 * 5 + totalDollars) / 60);
